import { action, observable } from "mobx";
import { WeaForm } from "comsMobx";
// import _ from 'lodash';
import { fields } from "../data/batchImport";
import {WeaLocaleProvider} from "ecCom";
const getLabel = WeaLocaleProvider.getLabel;

export default class BatchImportStore {
    @observable form = new WeaForm();
    @observable loading: boolean = false;
    @observable importUrl: string = '/api/cube/card/detailImport';
    @observable fields: any[] = fields;

    @observable uploadParams: any = {};
    @observable modename: string = '';
    @observable selectedFile: string = '';
    list: any;

    constructor(){
        this.form.initFormFields([{ items: fields }]);
        this.selectedFile = getLabel(132079,'未选择文件');
    }

    @action
    updateParams = () => {

    }

}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/stores/list/BatchImportStore.ts